import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

const document = graphql(`
  mutation DocumentReportListPage_CloneDocumentReport($documentReportId: ID!) {
    copyDocument(documentId: $documentReportId) {
      id
    }
  }
`)

export const useCloneDocumentReportMutation = (
  options: MutationOptions<string, string> = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (documentReportId) => {
      const result = await graphQLRequest({
        document,
        variables: { documentReportId },
      })
      const clonedDocumentReportId = result.copyDocument?.id
      if (!exists(clonedDocumentReportId)) {
        throw new Error(t('duplication_failed'))
      }

      return clonedDocumentReportId
    },
    ...options,
  })
}
